import styled from 'styled-components';

export const TooltipWrapper = styled.div`
    width: ${p => p.width ? p.width : '330px'};
    padding:1rem;
    border-radius: 0.4rem;
    border: solid 0.2rem ${p => p.borderColor ? p.borderColor : '#9bc2f6'};
    background-color: ${p => p.bgColor ? p.bgColor : '#d1e5ff'};
    position: absolute;
    left: ${p => p.left ? p.left : '0px'};
    top: ${p => p.top ? p.top : '2.6rem'};
    z-index: 1;
    :after, 
    :before {
        bottom: 100%;
        left: ${p => p.beforeLeft ? p.beforeLeft : '0px'};
        border: solid transparent;
        content: "";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }
    :after {
        border-color: rgba(209, 229, 255, 0);
        border-bottom-color: ${p => p.bgColor ? p.bgColor : '#d1e5ff'};
        border-width: 0.7rem;
        margin-left: -0.7rem;
    }
    :before {
        border-color: rgba(155, 194, 246, 0);
        border-bottom-color: ${p => p.borderColor ? p.borderColor : '#9bc2f6'};
        border-width: 1rem;
        margin-left: -1rem;
    }
`;

export const CabTitle = styled.div`
    border-radius: 1rem;
    background-color: #ffffff;
    padding: 0.2rem 1rem 0.2rem 0.5rem;
    display: inline-flex;
    align-items: center;
    margin-bottom: 1.5rem;
    .cabName{
        font-size: 1.2rem;
        color: ${p => p.color ? p.color : '#2276e3'}
    }
`;
export const CabDesc = styled.div`
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: normal;
    color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    text-align: left;
`;